import { Checkbox, FormControlLabel } from '@mui/material';
import { getSafeImageUrl } from '../../utils/securityUtil';
import { useSilentWitnessContext } from '../../contexts/SilentWitnessContext';
import { silentWitnessClasses } from './silentWitnessClasses';
import { cn } from "../../utils/classNames";

const imageItemCardClasses ='flex flex-col p-2';

const imageWrapperClasses ='mb-2 w-full h-[120px] overflow-hidden rounded bg-white flex items-center justify-center';

const imageClasses ='max-w-full max-h-full object-contain';

const imageNameWrapperClasses ='mb-2 w-full';

const imageNameClasses ='text-xs font-medium block truncate';

const imageCheckboxGroupClasses ='flex flex-wrap justify-center items-center gap-x-2 gap-y-1 w-full';

const imageLabelTextClasses ='text-xs font-medium';

const SilentWitnessImageItem = ({ item, groupKey }) => {
  const { selectedLiabilityItems, toggleItemSelection } = useSilentWitnessContext();
  const key = `${groupKey}-${item.index}`;
  const selection = selectedLiabilityItems[key] || { plaintiff: false, defendant: false };

  return (
    <div className={cn(imageItemCardClasses, silentWitnessClasses.itemCard)}>
      <div className={imageWrapperClasses}>
        <img
          src={getSafeImageUrl(item.data?.url, '/placeholder.png')}
          alt={item.name}
          className={imageClasses}
        />
      </div>

      <div className={imageNameWrapperClasses}>
        <span className={imageNameClasses} title={item.name}>
          {item.name}
        </span>
      </div>

      <div className={imageCheckboxGroupClasses}>
        <FormControlLabel
          className={silentWitnessClasses.formControlLabel}
          label={<span className={imageLabelTextClasses}>Plaintiff</span>}
          control={
            <Checkbox
              checked={selection.plaintiff}
              onChange={() =>
                toggleItemSelection({
                  itemKey: groupKey,
                  index: item.index,
                  type: 'plaintiff',
                })
              }
              size="small"
            />
          }
        />

        <FormControlLabel
          className={silentWitnessClasses.formControlLabel}
          label={<span className={imageLabelTextClasses}>Defendant</span>}
          control={
            <Checkbox
              checked={selection.defendant}
              onChange={() =>
                toggleItemSelection({
                  itemKey: groupKey,
                  index: item.index,
                  type: 'defendant',
                })
              }
              size="small"
            />
          }
        />
      </div>
    </div>
  );
};

export default SilentWitnessImageItem;
